/*eslint-disable*/
import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// @mui/material components
import withStyles from "@mui/styles/withStyles";
// core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import { Form, FormGroup, Label, Input, FormText } from "reactstrap";


import { ourLightGreen, ourMediumGreen, isAuthenticated, help_email } from "assets/jss/incept-sustainability-variables.jsx";

import axios from "axios";
import jwt from "jwt-decode";

import LoadingOverlay from "react-loading-overlay";
import BounceLoader from "react-spinners/BounceLoader";

import "bootstrap/dist/css/bootstrap.min.css";
import { blackColor } from "assets/jss/material-dashboard-react";

//Buttons
import ActionButton from "components/CustomButtons/ActionButton";

//Translations
import { withTranslation } from 'react-i18next';
import { submit_contact_support_url } from "assets/jss/incept-sustainability-variables";
import { Select, MenuItem } from "@mui/material";

const style = (theme) => ({
	typo: {
		paddingLeft: "25%",
		marginBottom: "40px",
		position: "relative",
	},
	titlepackage: {
		fontFamily: '"Raleway", "Helvetica", "Arial", sans-serif',
		fontStyle: "normal",
		//marginLeft: "1.2rem"
	},
	cont: {
		margin: "0 5px !important"
	},
	lineunder: {
		display: "block",
		border: "1px solid #116628",
		marginLeft: "-60px",
		width: "50%",
		marginBottom: "40px",
		color: "rgba(0, 0, 0, 0.87)",
	},
	buttoncolor: {
		backgroundColor: "#0095a9",
		borderColor: "#0095a9",
	},
	button: {
		width: "120px",
		backgroundColor: "rgb(255, 111, 105)",
		color: "white",
		border: "1px",
		borderRadius: "20px",
		cursor: "pointer",
		fontSize: "15px",
		padding: "2px 8px",
		display: "block",
		position: "inherit",
		float: "right",
		"&:hover": {
			backgroundColor: "#FF9894",
		},
	},
	wrapper: {
		// marginTop: "-9.5rem",
		marginLeft: "4rem",
		marginRight: "4rem",
		[theme.breakpoints.down('md')]: {
			margin: "0",
		},
		border: "1px solid red",
	},
	containerother: {
		// marginTop: "3rem",
		paddingLeft: "40px",
		[theme.breakpoints.down('md')]: {
			padding: "0 25px",
		},
	},
	input: {
		borderRadius: "16px",
		border: "1.5px solid lightgray",
	},
	kickOff: {
		borderRadius: "16px",
		padding: "1rem 1rem 0 1rem",
		backgroundColor: ourLightGreen,
		marginTop: "15px",
		marginBottom: "0.8rem",
	},
	didYouKnow: {
		marginBottom: "2.2rem",
		borderRadius: "16px",
		padding: "0 1rem 2rem 1rem",
		backgroundColor: "white",
		"& p, strong": {
			color: "black",
			[theme.breakpoints.down('md')]: {
				marginRight: "0",
			},
		},
	},
	welcomeGridButton: {
		width: "120px",
		backgroundColor: "rgb(255, 111, 105)",
		color: "white",
		border: "1px",
		float: "right",
		borderRadius: "16px",
		cursor: "pointer",
		fontSize: "13px",
		padding: "2px 8px",
		display: "block",
		position: "inherit",
		marginTop: "1.5rem",
	},
	moduleCard: {
		borderRadius: "16px",
		marginBottom: "2.2rem",
	},
});

class Help extends React.Component {
	constructor(props) {
		super(props);
		var redlog = false;
		var decodedtoken = "";
		if (!isAuthenticated()) {
			redlog = true;
		}
		else
			decodedtoken = jwt(localStorage.getItem("token"));
		this.state = {
			title: "",
			description: false,
			loading: false,
			userid: (decodedtoken!="") ? decodedtoken.userid:"",
			type: "general_support",
		};
		this.handleSubmitForm = this.handleSubmitForm.bind(this);
	}

	handleSubmitForm() {
		if (!isAuthenticated()) {
			this.props.isExpired();
		}
		if (this.state.title == "") {
			alert("Title cannot be empty");
			return;
		} else if (this.state.description == "") {
			alert("Description cannot be empty");
			return;
		}

		document.getElementById("thankyoudiv").style.display = "none";
		document.getElementById("errordiv").style.display = "none";

		this.setState({ loading: true });
		const formdata = {
			subject: this.state.title,
			text: this.state.description,
			contact_request_type: this.state.type,
		};

		const fireSubmitEvent = () => {
			// Fire an event
			axios.post(submit_contact_support_url, {
				subjectType: this.state.type === "general_support" ? "general" : "technical",
			}, {
				headers: {
					Authorization: authstr
				}
			}).catch(_ => {})
		}

		const token = localStorage.getItem("token");
		const authstr = "Bearer " + token;

		this.setState({ loading: true }, () => {
			axios
				.post(help_email, formdata, { headers: { Authorization: authstr } })
				.then((res) => {
					this.setState({ loading: false, title: "", description: "" });
					document.getElementById("thankyoudiv").style.display = "block";
					fireSubmitEvent();
				})
				.catch((err) => {
					if (err.response!==undefined)
						console.log(err.response.data.message);
					else 
						console.log(err);
					this.setState({ loading: false });
					document.getElementById("errordiv").style.display = "block";
				});
		});


	}
	render() {
		const { classes, t } = this.props;
		return (
			<LoadingOverlay active={this.state.loading} spinner={<BounceLoader />}>
				<h2 className={classes.titlepackage} style={{ fontFamily: "gotham-font-medium", paddingTop: "1.5rem", paddingLeft: "40px" }}> {t('Contact')} </h2>
				<div className={classes.containerother}>
					<GridContainer className={classes.cont}>
						<GridItem xs={12} sm={12} md={9} spaceLeft={0}>
							<Card className={classes.kickOff}>
								<CardBody style={{ padding: "1rem" }}>
									<p>
										{t('helptext2')}
									</p>
								</CardBody>
							</Card>
						</GridItem>
						<GridItem xs={12} sm={12} md={9} spaceLeft={0}>
							<Card className={classes.didYouKnow}>
								<CardBody>
									<Form>
									<FormGroup>
											<Label
												for="type"
												style={{ color: blackColor, fontWeight: "bold" }}
											>
												{t('Type of request')}
											</Label>

											{/* I am just going to use inline styling here, we will move this to the new app anyway */}
											<Select
											    value={this.state.type}
												style={{ width: "100%", borderRadius: "16px", height: "42px", }}
												// To make it consistent look with other inputs
												sx={{ "&.Mui-focused .MuiOutlinedInput-notchedOutline" : {boxShadow: "0 0 0 4px #c2dbfe", borderColor: "#86b7fe", border: "1px solid #86b7fe", borderRadius: "16px",},
												".MuiOutlinedInput-notchedOutline": {
													borderRadius: "16px",
													border: "none",
												}
												}}
												className={classes.input}
												id="type"
												onChange={(e) =>
													this.setState({ type: e.target.value })
												}>
													
     											 <MenuItem value="general_support">{t("General Support")}</MenuItem>
												 <MenuItem value="technical_support">{t("Technical Support")}</MenuItem>
											</Select>
										</FormGroup>
										<FormGroup>
											<Label
												for="titleform"
												style={{ color: blackColor, fontWeight: "bold" }}
											>
												{t('Subject')}
											</Label>
											<Input
												className={classes.input}
												type="text"
												name="title"
												id="titleform"
												placeholder=""
												onChange={(e) =>
													this.setState({ title: e.target.value })
												}
											/>
										</FormGroup>
										<FormGroup>
											<Label
												for="textform"
												style={{ color: blackColor, fontWeight: "bold" }}
											>
												{t('Message')}
											</Label>
											<Input
												className={classes.input}
												type="textarea"
												name="text"
												id="textform"
												height="168px"
												rows="6"
												onChange={(e) =>
													this.setState({ description: e.target.value })
												}
											/>
										</FormGroup>
										<div
											id="thankyoudiv"
											style={{
												color: "green",
												marginBottom: "20px",
												display: "none",
											}}
										>
											{t('We will reach you', { defaultValue: 'Thank you for your message. We will reach back as soon as possible.' })}
										</div>
										<div
											id="errordiv"
											style={{
												color: "red",
												marginBottom: "20px",
												display: "none",
											}}
										>
											{t('There was an error', {
												defaultValue: 'There was an error, please try again or contact us at inceptsustainability@ramboll.com.'
											})}
										</div>
										<ActionButton
											style={{width:"auto"}}
											onClick={this.handleSubmitForm}
										>
											{t('Submit')}
										</ActionButton>
									</Form>
								</CardBody>
							</Card>
						</GridItem>
					</GridContainer>
				</div>
			</LoadingOverlay>
		);
	}
}

Help.propTypes = {
	classes: PropTypes.object.isRequired,
};

export default withTranslation()(withStyles(style)(Help));
